var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "leo-hidden tablet:leo-flex leo-w-full leo-flex-row leo-bg-white leo-items-center leo-gap-md leo-py-xl leo-px-7xl leo-w-screen",
      },
      [
        _c("div", [
          _c(
            "a",
            {
              staticClass:
                "leo-text-sm leo-cursor-pointer leo-text-grey-600 leo-font-semibold",
              attrs: { href: _vm.termConditionURL, target: "_blank" },
            },
            [_vm._v(_vm._s(_vm.footerProps.termConditionLabel))]
          ),
        ]),
        _vm.isGELS
          ? _c("div", [
              _c(
                "a",
                {
                  staticClass:
                    "leo-text-sm leo-cursor-pointer leo-text-grey-600 leo-font-semibold",
                  attrs: { href: _vm.policiesNoticesURL, target: "_blank" },
                },
                [_vm._v(_vm._s(_vm.footerProps.policiesNoticesLabel))]
              ),
            ])
          : _vm._e(),
        !_vm.isGELS
          ? _c("div", [
              _c(
                "a",
                {
                  staticClass:
                    "leo-text-sm leo-cursor-pointer leo-text-grey-600 leo-font-semibold",
                  attrs: {
                    href: _vm.personalDataProtectionNoticeURL,
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.footerProps.personalDataProtectionNoticeLabel)
                  ),
                ]
              ),
            ])
          : _vm._e(),
        !_vm.isGELS
          ? _c("div", [
              _c(
                "a",
                {
                  staticClass:
                    "leo-text-sm leo-cursor-pointer leo-text-grey-600 leo-font-semibold",
                  attrs: { href: _vm.PIDMTipsBrochureURL, target: "_blank" },
                },
                [_vm._v(_vm._s(_vm.footerProps.PIDMTipsBrochureLabel))]
              ),
            ])
          : _vm._e(),
        !_vm.isGELS
          ? _c("div", [
              _c(
                "a",
                {
                  staticClass:
                    "leo-text-sm leo-cursor-pointer leo-text-grey-600 leo-font-semibold",
                  attrs: { href: _vm.aboutPIDMProtectionURL, target: "_blank" },
                },
                [_vm._v(_vm._s(_vm.footerProps.aboutPIDMProtection))]
              ),
            ])
          : _vm._e(),
        _c(
          "p",
          {
            staticClass: "leo-text-grey-600 leo-ml-auto leo-text-xs",
            staticStyle: { "max-width": "592px" },
          },
          [_vm._v(" " + _vm._s(_vm.footerProps.copyRights) + " ")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }